export default __webpack_public_path__ + "images/ListadoFacturas-FR.png";